import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { PopupDropdownMenu } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import { primaryTextColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { forwardRef } from 'react';
const detailWrapperCss = "d1p3ngo6";
const DetailWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(detailWrapperCss, props.className)} />;
});
const dropDownCss = "d3vwva4";
const DropDown = forwardRef((props, ref) => <PopupDropdownMenu ref={ref} {...props} className={classNames(dropDownCss, props.className)} />);
const infoContainerCss = "i1k7lf5v";
const InfoContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoContainerCss, props.className)} />;
});
const extraUsersContainerCss = "e1uv5vpx";
const ExtraUsersContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(extraUsersContainerCss, props.className)} />;
});
const infoTextCss = "i10jcrg3";
const InfoText = forwardRef((props, ref) => {
  const color = primaryTextColor;
  return <BodyText ref={ref} {...props} color={color} className={classNames(infoTextCss, props.className)} />;
});
const UserInfoList = ({
  users
}) => {
  const usersToShow = users.length > 5 ? users.slice(0, 5) : users;
  const extraUsers = users.length > 5 ? users.length - 5 : 0;
  return <DropDown>
      {usersToShow.map(user => <InfoContainer key={user.uuid}>
          <InfoText>{user.name}</InfoText>
        </InfoContainer>)}
      {extraUsers > 0 && <ExtraUsersContainer>
          <InfoText>{I18n.t('publisher.meetings.event_type_info.more', {
          count: extraUsers
        })}</InfoText>
        </ExtraUsersContainer>}
    </DropDown>;
};
export const AccessInfo = ({
  usersWithAccess = []
}) => {
  const [toggleDropdown, Wrapper, isDropdownOpen] = useDropdown();
  if (isEmpty(usersWithAccess)) return null;
  const count = usersWithAccess.length;
  const countText = I18n.t('publisher.meetings.event_type_info.access.count', {
    count
  });
  const suffixText = I18n.t('publisher.meetings.event_type_info.access.suffix', {
    count
  });
  return <>
      <BodyText size="medium" color="muted">
        <DetailWrapper onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown}>
          {countText}
        </DetailWrapper>
        {' '}
        {suffixText}
      </BodyText>
      <Wrapper>
        {isDropdownOpen && <UserInfoList title={I18n.t('publisher.event_types.non_hosts')} users={usersWithAccess} />}
      </Wrapper>
    </>;
};

require("./access_info.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./access_info.js");